import Alpine from "alpinejs"

Alpine.data(
    "dropDownFilter",
    (filterId, totalItems, multiSelect = true, defaultSelected = [], showCurrent = false) => ({
        open: false,
        disabled: false,
        totalItems: Number(totalItems),
        selectedItems: [],
        multiSelect: multiSelect,
        showCurrent: showCurrent,

        init() {
            this.selectedItems = Array.isArray(defaultSelected) ? defaultSelected : []

            // If there are default items, dispatch events for each
            if (this.selectedItems.length > 0) {
                this.selectedItems.forEach((item) => {
                    const event = new CustomEvent("dropdown:add-item", {
                        bubbles: true,
                        detail: {
                            id: filterId,
                            identifier: item.identifier,
                            title: item.title,
                        },
                    })
                    this.$el.dispatchEvent(event)
                })
            }

            // Listen for form reset events with a generic name
            document.addEventListener("form:reset", (event) => {
                // Check if this event is meant for this dropdown or all dropdowns
                if (!event.detail.filterId || event.detail.filterId === filterId) {
                    this.selectedItems = []
                }
            })

            this.$el.addEventListener("dropdown:disable-filter", (event) => {
                event.stopPropagation()
                // Only disable if there's an active filter and it's not this one
                this.disabled = event.detail.enabledId !== null && event.detail.enabledId !== filterId
            })

            this.$el.addEventListener("dropdown:clear-items", (event) => {
                if (event.detail.id === filterId) {
                    this.selectedItems = []
                }
            })
        },

        selectItem(identifier, title) {
            if (this.disabled) return

            // Handle single vs multi select
            if (this.multiSelect) {
                const existingItemIndex = this.selectedItems.findIndex((item) => item.identifier === identifier)
                if (existingItemIndex >= 0) {
                    // Item exists, remove it (deselect)
                    this.selectedItems.splice(existingItemIndex, 1)

                    // Dispatch a remove event
                    const removeEvent = new CustomEvent("dropdown:remove-item", {
                        bubbles: true,
                        detail: {
                            id: filterId,
                            identifier,
                            title,
                        },
                    })
                    this.$el.dispatchEvent(removeEvent)
                } else {
                    // Item doesn't exist, add it (select)
                    this.selectedItems.push({ identifier, title })

                    // Dispatch an add event
                    const addEvent = new CustomEvent("dropdown:add-item", {
                        bubbles: true,
                        detail: {
                            id: filterId,
                            identifier,
                            title,
                        },
                    })
                    this.$el.dispatchEvent(addEvent)
                }
                // In multi-select mode, don't close the dropdown
            } else {
                this.selectedItems = [{ identifier, title }]
                // Only close the dropdown if not in multi-select mode
                this.open = false

                // Dispatch an add event
                const event = new CustomEvent("dropdown:add-item", {
                    bubbles: true,
                    detail: {
                        id: filterId,
                        identifier,
                        title,
                    },
                })
                this.$el.dispatchEvent(event)
            }
        },

        removeSelected() {
            this.selectedItems = []
            const event = new CustomEvent("dropdown:clear-items", {
                bubbles: true,
                detail: { id: filterId },
            })
            this.$el.dispatchEvent(event)
            // Close the dropdown after clearing
            this.open = false
        },

        getSelectedLabels() {
            return this.selectedItems.length > 0
                ? this.selectedItems.map((item) => item.title).join(", ")
                : "Bitte wählen"
        },

        availableItems() {
            return this.multiSelect
                ? this.totalItems - this.selectedItems.length
                : this.selectedItems.length === 0
                ? this.totalItems
                : 0
        },

        isItemSelected(identifier) {
            return this.selectedItems.some((item) => item.identifier === identifier)
        },
    }),
)
